<div class="sales-reports-container">
  <h2>Sales Reports</h2>

  <div *ngFor="let report of salesReport" class="sales-report-card">
    <h3>Date: {{ report.date }}</h3>
    <p><strong>Total Sales:</strong> {{ report.totalSales }}</p>
    <p><strong>Total Orders:</strong> {{ report.totalOrders }}</p>
    <p><strong>Average Order Value:</strong> {{ report.avgOrderValue }}</p>

    <div class="payment-breakdown">
      <h4>Payment Breakdown</h4>
      <ul>
        <li><strong>Cash:</strong> {{ report.paymentBreakdown.cash }}</li>
        <li><strong>Card:</strong> {{ report.paymentBreakdown.card }}</li>
        <li><strong>PayPal:</strong> {{ report.paymentBreakdown.paypal }}</li>
        <li><strong>Stripe:</strong> {{ report.paymentBreakdown.stripe }}</li>
      </ul>
    </div>

    <div class="fees-breakdown">
      <h4>Fees & Deductions</h4>
      <ul>
        <li>
          <strong>Transaction Fees:</strong> {{ report.fees.transactionFees }}
        </li>
        <li><strong>50p Order Fees:</strong> {{ report.fees.orderFees }}</li>
        <li><strong>Total Fees:</strong> {{ report.fees.totalFees }}</li>
        <li><strong>Net Revenue:</strong> {{ report.fees.netRevenue }}</li>
      </ul>
    </div>
  </div>
</div>
